import { render } from "./GimBrandAdmin.vue?vue&type=template&id=c8e45368"
import script from "./GimBrandAdmin.vue?vue&type=script&lang=js"
export * from "./GimBrandAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__